var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuCollectionNftIcon = function SvgMenuCollectionNftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108602",
    d: "M0 1.144A1.145 1.145 0 0 1 1.145 0h8.012A1.145 1.145 0 0 1 10.3 1.144v8.008a1.144 1.144 0 0 1-1.145 1.144h-8.01A1.145 1.145 0 0 1 0 9.152Zm2.289 6.867V2.289h5.723v5.722Z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108603",
    d: "M11.446 12.587a1.145 1.145 0 0 1 1.145-1.144h8.011a1.145 1.145 0 0 1 1.145 1.144v8.011a1.145 1.145 0 0 1-1.145 1.144h-8.011a1.145 1.145 0 0 1-1.145-1.143Zm2.289 6.867v-5.722h5.723v5.722Z",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108604",
    d: "M12.591 0a1.145 1.145 0 0 0-1.145 1.144v8.008a1.145 1.145 0 0 0 1.145 1.144h8.011a1.145 1.145 0 0 0 1.144-1.144V1.144A1.145 1.145 0 0 0 20.601 0Zm1.145 2.289v5.722h5.723V2.289Z",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108605",
    d: "M0 12.587a1.145 1.145 0 0 1 1.145-1.144h8.012a1.145 1.145 0 0 1 1.145 1.144v8.011a1.145 1.145 0 0 1-1.145 1.144H1.145A1.145 1.145 0 0 1 0 20.599Zm2.289 6.867v-5.722h5.723v5.722Z",
    fillRule: "evenodd"
  })));
};
export default SvgMenuCollectionNftIcon;